<template>
  <div class="footer_fuild w_100">
    <div class="footer">
      <div class="footer_top between">
        <div class="fot_l_logo">
          <img src="~assets/base/logo_sample.png" alt="" />
        </div>
        <div class="fot_r_cont">
          <div class="tlift FontSize14 cor_fff">
            <span>关于我们</span>
            <span>联系我们</span>
            <span>客服中心</span>
            <span>网站地图</span>
            <span>客服电话：（工作日 08:30-18:00）400-000-1000</span>
            <span>客服邮箱：2211111111@qq.com</span>
          </div>
          <div class="fot_ify between">
            <div class="ify_item">
              <div class="fot_title">律观网保障</div>
              <div>常见问题解答</div>
              <div>交易模式</div>
              <div>规则体系</div>
              <div>保障体系</div>
              <div>争议处理</div>
            </div>
            <div class="ify_item">
              <div class="fot_title">律观网保障</div>
              <div>常见问题解答</div>
              <div>交易模式</div>
              <div>规则体系</div>
              <div>保障体系</div>
              <div>争议处理</div>
            </div>
            <div class="ify_item">
              <div class="fot_title">律观网保障</div>
              <div>常见问题解答</div>
              <div>交易模式</div>
              <div>规则体系</div>
              <div>保障体系</div>
              <div>争议处理</div>
            </div>
            <div class="ify_item">
              <div class="fot_title">律观网保障</div>
              <div>常见问题解答</div>
              <div>交易模式</div>
              <div>规则体系</div>
              <div>保障体系</div>
              <div>争议处理</div>
            </div>
            <div class="ewm">
              <div><img src="~assets/base/ewm_sample.png" alt="" /></div>
              <div>免费咨询 随时追问</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        隐私声明 服务协议 Copyright © 2019-2021 安徽欧乐美科技有限公司 版权所有
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="nofollow" style="color: #666666;">皖ICP备10206647号-17</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scope>
.footer_fuild {
  background-color: #202020;
  .footer {
    color: #666666;
    padding-top: 56px;
    .cor_fff {
      color: #fff;
    }
    .footer_top {
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 60px;
      .tlift {
        span {
          padding: 0 14px;
          border-right: 1px solid #fff;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
      .fot_l_logo {
        font-size: 60px;
        width: 250px;
        img {
          filter: invert(50%);
          width: 150px;
        }
      }

      .fot_r_cont {
        flex: 1;
        .fot_ify {
          margin-top: 22px;
          font-size: 12px;
          .ify_item {
            > div {
              margin-top: 12px;
            }
            .fot_title {
              color: #fff;
              font-size: 14px;
              margin-bottom: 32px;
            }
          }
          .ewm {
            align-self: start;
            text-align: center;
            color: #fff;
            font-size: 16px;
            img {
              margin-bottom: 21px;
            }
          }
        }
      }
    }
    .footer_bottom {
      padding: 25px;
      text-align: center;
      border-top: 1px solid #373737;
    }
  }
}
</style>
